module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@3x-004755170559f89dd354c432eaa22a0d.png";